module.exports = __webpack_public_path__ + "assets/2e99ac5b0c1129d1af7235173c70d535.png";